module.exports = {"130127100":"高邑镇","130127101":"大营镇","130127102":"富村镇","130127103":"万城镇","130127104":"中韩镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130127.json
// module id = 154
// module chunks = 0